const routes = [
  {
    path: "/manutencao-categoria-afastamento",
    name: "manutencao-categoria-afastamento",
    meta: {
      allowedPermissions: ["categoria_afastamento_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoCategoriaAfastamento/ManutencaoCategoriaAfastamentoHome.vue"
      ),
  },
  {
    path: "/manutencao-categoria-afastamento/novo",
    name: "manutencao-categoria-afastamento-novo",
    meta: {
      allowedPermissions: ["categoria_afastamento_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoCategoriaAfastamento/ManutencaoCategoriaAfastamentoCad.vue"
      ),
  },
  {
    path: "/manutencao-categoria-afastamento/editar/:id",
    name: "manutencao-categoria-afastamento-editar",
    meta: {
      allowedPermissions: ["categoria_afastamento_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoCategoriaAfastamento/ManutencaoCategoriaAfastamentoEdit.vue"
      ),
  },
];

export default routes;
